import { Dispatch } from 'redux';

import { User } from '../@types/User';
import { setAdministrador, setAdministradores } from '../actions/actionsAdmin';
import { setCliente, setServicosCliente } from '../actions/actionsCliente';
import { setPropertiesHeap } from './HeapConfig';
import { getFirstPanelPath, getPostLoginDestination } from './postLoginDestination';
import { setPropertiesTagManager } from './TagManagerProperties';

type BiPanel = { codigo: string | null; nome?: string };

export type UserInformation = {
  usuario: {
    login: string;
    pessoaFisica: { nome: string };
    organizacao: { nome: string };
  };
};

export type ClientCompleteData = Omit<User, 'servicoBi'> & {
  servicoBi: { analises: BiPanel[] | null; graficos: BiPanel[] | null } | null;
  servicoIra?: unknown;
};

export const getInitialRoute = (data: ClientCompleteData) => {
  const destination = getPostLoginDestination(data as unknown as User);
  if (destination.type === 'path') return destination.path;
  if (destination.type === 'panels') return getFirstPanelPath(data as unknown as User) ?? undefined;
  return undefined;
};

export const mapUserData = (userData: UserInformation) => ({
  email: userData.usuario.login,
  nome: userData.usuario.pessoaFisica.nome,
});

export const mapClientData = (clientData: ClientCompleteData, userData: UserInformation) => ({
  codigo: clientData.codigoCliente,
  nome: clientData.cliente,
  organizacao: userData.usuario.organizacao.nome,
});

export const saveUserSession = (userData: UserInformation, clientData: ClientCompleteData, token: string) => {
  localStorage.setItem('usuario', JSON.stringify(mapUserData(userData)));
  localStorage.setItem('cliente', JSON.stringify(mapClientData(clientData, userData)));
  localStorage.setItem('autenticacao.token', token);
};

export const dispatchClientData = (dispatch: Dispatch, clientData: ClientCompleteData) => {
  dispatch(setCliente(clientData.codigoCliente));
  dispatch(setAdministrador(clientData.usuarioAdministrador));
  dispatch(setServicosCliente(clientData.servicosCliente));
  dispatch(setAdministradores(clientData.administradores));
};

export const setUserLogProperties = (clientData: ClientCompleteData) => {
  setPropertiesTagManager(clientData);
  setPropertiesHeap(clientData);
};
